import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    standalone: false
})
export class ConfirmationComponent
{
    @Input()
    title: string;
    @Input()
    message: string;
    @Input()
    btnOkText: string;
    @Input()
    btnCancelText: string;
    @Input()
    showOnlyOkBtb: boolean;

    constructor(private activeModal: NgbActiveModal)
    {
    }

    public closeModal()
    {
        this.activeModal.close();
    }

    public decline()
    {
        this.activeModal.close(false);
    }

    public accept()
    {
        this.activeModal.close(true);
    }

    public dismiss()
    {
        this.activeModal.dismiss();
    }
}